import { lazy } from 'react';

const ShopPointsFaq = lazy(() => import(/* webpackChunkName: "shop" */ './components/shop-points-faq'));

export default ShopPointsFaq;
